<template>
  <div class="apply-agent-page">
    <div class="header">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('Become Agent') }}</h1>
      <div class="header-right"></div>
    </div>

    <div class="content">
      <div v-if="applyStatus === 'approved'" class="status-card">
        <div class="status-title">{{ $t('Already an agent') }}</div>
        <button class="gold-btn" @click="$router.push('/agentCenter')">{{ $t('Go to Agent Center') }}</button>
      </div>

      <div v-else-if="applyStatus === 'pending'" class="status-card">
        <div class="status-title">{{ $t('Agent Pending Review') }}</div>
        <p class="status-text">{{ $t('Please wait for review') }}</p>
      </div>

      <div v-else class="form-card">
        <div v-if="applyStatus === 'refused'" class="refuse-tip">{{ $t('Agent Application Refused') }}</div>
        <div class="field">
          <label>{{ $t('Username') }}</label>
          <input type="text" :value="$store.state.userInfo.username" disabled>
        </div>
        <div class="field">
          <label>{{ $t('Contact') }}</label>
          <input type="text" v-model="info.mobile" :placeholder="$t('Please enter phone or email')">
        </div>
        <div class="field">
          <label>{{ $t('Apply Reason') }}</label>
          <textarea v-model="info.apply_info" :placeholder="$t('Please enter apply reason')"></textarea>
        </div>
        <button class="gold-btn" @click="shenqing">{{ applyStatus === 'refused' ? $t('Re-apply') : $t('Join Us') }}</button>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Foot from './libs/Foot';

export default {
  name: 'applyagent',
  components: {
    Foot
  },
  data() {
    return {
      info: {
        mobile: '',
        apply_info: '',
      },
      applyStatus: 'none',
    };
  },
  created() {
    this.loadStatus();
  },
  methods: {
    loadStatus() {
      this.$apiFun.get('/api/agent/home').then((res) => {
        if (res && res.code === 200 && res.data) {
          this.applyStatus = res.data.apply_status || 'none';
        }
      }).catch(() => {});
    },
    shenqing() {
      const contact = String(this.info.mobile || '').trim();
      if (!contact) {
        this.$parent.showTost(0, this.$t('Please enter phone or email'));
        return;
      }
      if (!this.info.apply_info || !String(this.info.apply_info).trim()) {
        this.$parent.showTost(0, this.$t('Please enter apply reason'));
        return;
      }
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/applyagentdo', {
          mobile: contact,
          apply_info: String(this.info.apply_info).trim(),
        })
        .then((res) => {
          this.$parent.hideLoading();
          this.$parent.showTost(res.code === 200 ? 1 : 0, res.message);
          if (res.code === 200) {
            this.applyStatus = 'pending';
          }
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-agent-page {
  min-height: 100vh;
  background: #ffffff;
  color: #352b24;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;

  .back, .header-right {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1 {
    font-size: 18px;
    margin: 0;
  }
}

.content {
  padding: 16px 16px calc(92px + env(safe-area-inset-bottom));
}

.status-card,
.form-card {
  background: #fff;
  border: 1px solid #eadfd3;
  border-radius: 16px;
  padding: 18px 16px;
  box-shadow: 0 5px 18px rgba(117, 73, 34, 0.08);
}

.status-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}

.status-text,
.refuse-tip {
  color: #8a6a4a;
  margin-bottom: 14px;
}

.field {
  margin-bottom: 14px;

  label {
    display: block;
    font-size: 13px;
    margin-bottom: 6px;
    color: #8f501f;
  }

  input, textarea {
    width: 100%;
    border: 1px solid #ead1b2;
    border-radius: 8px;
    padding: 10px;
    background: #fff8ef;
    box-sizing: border-box;
    color: #352b24;
  }

  textarea {
    min-height: 90px;
  }
}

.gold-btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/applyagent.vue